export function handler (config) {
    config.headers.Authorization = `Bearer ${localStorage.getItem('accessToken')}`
    return config
}

export function onError (error) {
    return Promise.reject(error)
}
